module.exports = __webpack_public_path__ + "static/media/emina.cb189344.png";